import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { AppService } from 'app/app.service';
import { DateTime } from 'luxon';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { environment } from '@environments/environment';
import { Observable, tap } from 'rxjs';
import { SignalsService } from '@shared/services/signals/signals.service';

@Component({
  selector: 'app-feedback',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbComponent,
    DropdownModule,
    InputMaskModule,
    InputTextareaModule,
    ButtonModule
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent {

  form: FormGroup = new FormGroup('');

  feedbackTypes: string[] = ['General', 'Bug', 'Feature Request', 'Data Error', 'Compliment', 'Other'];
  viewTypes: string[] = ['Flights', 'Flight Detail', 'Sequence Detail', 'Calendar', 'Analyze', 'Charts', 'Search', 'All', 'Other'];

  empNumber$?: Observable<string>;
  _empNumber: string = '';
  deviceType: string = this.getDeviceType();

  constructor(
    public appService: AppService,
    private signalService: SignalsService,
  ) { }


  getDeviceType(): string {
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      return 'Android';
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      return 'iOS';
    } else if (/Windows/.test(userAgent)) {
      return 'Windows';
    } else if (/Macintosh/.test(userAgent)) {
      return 'Mac';
    } else {
      return 'Unknown';
    }
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      feedbackType: new FormControl<string | null>(null),
      view: new FormControl<string | null>(null),
      contactNumber: new FormControl<string | null>(null),
      feedbackText: new FormControl<string | null>(null)
    },
      {
        validators: this.formValidator
      });

    this.empNumber$ = this.signalService.employeeNumber$.pipe(
      tap((empNum) => {
        this._empNumber = empNum;
      })
    )
  }

  formValidator(control: AbstractControl): ValidationErrors | null {
    const feedbackType = control.get('feedbackType')?.value;
    const view = control.get('view')?.value;
    const feedbackText = control.get('feedbackText')?.value;

    if (!feedbackType || !view || !feedbackText) {
      return { 'incompleteForm': true };
    } else return null;
  }

  hasNoFormValues() {
    return (this.form.errors?.incompleteForm && this.form.dirty) ?? false;
  }

  onReset(): void {
    this.form.reset();
  }

  onSubmit(): void {
    const feedbackType = this.form.get('feedbackType')?.value;
    const email = "logbookfeedback@alliedpilots.org";
    const subject = encodeURIComponent(`Logbook v${environment.appVersion} - ${feedbackType} Feedback`);
    let body = this.generateMailBody(feedbackType);
    body = encodeURIComponent(body).replace(/%0A/g, "%0D%0A"); // Ensures correct encoding of new lines for email
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  }

  generateMailBody(type: string): string {
    const _errorlogs = sessionStorage.getItem('errorLog');
    const errorLogs = _errorlogs ? JSON.parse(_errorlogs) : '';


    const view = this.form.get('view')?.value;
    const contactNumber = this.form.get('contactNumber')?.value || 'N/A';
    const feedbackText = this.form.get('feedbackText')?.value;
    
    return `
    ${type} Feedback\n
    View:  ${view}
    Feedback Summary:  ${feedbackText}\n\n
    NOTE:  Please provide screenshots or videos if applicable.\n\n
    Do not delete below this line
    -------------------------------------\n
    Employee Number: ${this._empNumber}
    Contact Number: ${contactNumber}
    Time Stamp: ${DateTime.now().toISODate()}
    Logbook App Version: ${environment.appVersion}
    Device: ${this.deviceType}\n
    Operating System: ${window.navigator.userAgent}\n
    Error Logs: ${errorLogs}\n
    `
  }
}
